import { alpha, styled } from '@mui/material';

export const DiffText = styled('div')(({ theme }) => ({
  fontFamily: 'monospace',
  fontSize: 13,
  lineHeight: 1.6,
  padding: theme.spacing(0, 1),
  whiteSpace: 'pre-wrap',
  overflowWrap: 'anywhere',
  '& mark': { color: 'inherit', borderRadius: 2 },
  '&[data-kind="added"]': { backgroundColor: alpha(theme.palette.success.main, 0.15) },
  '&[data-kind="added"] mark': { backgroundColor: alpha(theme.palette.success.main, 0.4) },
  '&[data-kind="removed"]': { backgroundColor: alpha(theme.palette.error.main, 0.15) },
  '&[data-kind="removed"] mark': { backgroundColor: alpha(theme.palette.error.main, 0.4) },
  '&[data-kind="empty"]': { backgroundColor: theme.palette.action.hover },
}));

export const LineNumber = styled(DiffText)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: 'right',
  whiteSpace: 'nowrap',
  userSelect: 'none',
  '&[data-side="right"]': { borderLeft: `1px solid ${theme.palette.divider}` },
}));
